import { connect } from "react-redux";

import * as accountingActions from "./actions";
import * as ordersActions from "../orders/actions";
import * as originatorActions from "../marketplace/originator/actions";

import states from "../../routes.states";
import { transfer_invoice_payment, prepare_for_new_transfer } from "./actions";

//Used to format the dates correctly without timezone (ToDo add this globally somehow?)
import moment from "moment";

function mapStateToProps(state, ownProps) {
  const locationObject =
    ownProps.location ?? state.routing.locationBeforeTransitions;

  let isStateDeposits =
    locationObject?.pathname === states["matchPaymentsDeposits"].url ||
    locationObject?.pathname === states["confirmPaymentsDeposits"].url ||
    locationObject?.pathname === states["confirmInvestorDeposits"].url;

  return {
    accounting: state.accounting,
    deposits: state.orders.deposit,
    invoices: state.invoices.invoices,
    stInvoices: state.invoices.shortTermInvoices,
    factoringInvoices: state.marketplace.factoring.invoice,
    initialSelectedIndex: isStateDeposits ? 0 : 1,
    marketplace: state.marketplace,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getAccountingEurope: () => {
      dispatch(accountingActions.get_accounting_europe());
    },

    getAccountingSweden: () => {
      dispatch(accountingActions.get_accounting_sweden());
    },

    changeAccountingListPageEurope: (page) => {
      dispatch(accountingActions.change_accounting_list_page_europe(page));
    },

    changeAccountingListPageSweden: (page) => {
      dispatch(accountingActions.change_accounting_list_page_sweden(page));
    },

    changeAccountingListFilterEurope: (keyName, event) => {
      dispatch(
        accountingActions.change_accounting_list_filter_europe(
          keyName,
          event.target.value,
        ),
      );
    },

    changeAccountingListFilterSweden: (keyName, event) => {
      dispatch(
        accountingActions.change_accounting_list_filter_sweden(
          keyName,
          event.target.value,
        ),
      );
    },

    exportAccountingEurope: () => {
      dispatch(accountingActions.export_accounting_europe());
    },

    exportAccountingSweden: () => {
      dispatch(accountingActions.export_accounting_sweden());
    },

    getMatchedData: () => {
      dispatch(accountingActions.fetch_investor_deposits_to_transfer());
      dispatch(accountingActions.get_invoice_matched_payments());
    },

    getUnmatchedInvoiceData: () => {
      dispatch(accountingActions.get_invoice_payments());
    },

    getDepositMatches: (toMatch, deposits) => {
      dispatch(accountingActions.get_deposit_matches(toMatch, deposits));
    },

    matchDepositManually: (depositId, paymentId, depositPayments) => {
      dispatch(
        accountingActions.match_deposit_manually(
          depositId,
          paymentId,
          depositPayments,
        ),
      );
    },

    matchInvoiceManually: (invoice, paymentId, invoicePayments) => {
      dispatch(
        accountingActions.match_invoice_manually(
          invoice,
          paymentId,
          invoicePayments,
        ),
      );
    },

    registerPayment: (paymentData, type) => {
      paymentData.BankReceiveDate = moment(paymentData.BankReceiveDate).format(
        "YYYY-MM-DD",
      );

      dispatch(accountingActions.register_payment(paymentData, type));
    },

    changeInvestorDepositOcr: (investorDepositId, ocr) => {
      dispatch(
        accountingActions.change_investor_deposit_ocr(investorDepositId, ocr),
      );
    },

    sendBackDeposit: (investorDepositId, bankAccountNumber, bankName) => {
      dispatch(
        accountingActions.send_back_deposit(
          investorDepositId,
          bankAccountNumber,
          bankName,
        ),
      );
    },

    registerInvoiceBatchPayment: (batch) => {
      dispatch(accountingActions.register_invoice_batch_payment(batch));
    },

    clearNumbersOnMount: (list) => {
      dispatch(prepare_for_new_transfer(list.length));
    },

    transferInvoicePayment: (list, bankReceiveDate) => {
      dispatch(prepare_for_new_transfer(list.length));
      dispatch(transfer_invoice_payment(list, bankReceiveDate));
    },

    approveDepositOrder: (
      orderId,
      accountId,
      depotId,
      paymentId,
      amount,
      date,
    ) => {
      dispatch(
        ordersActions.approve_deposit_order(
          orderId,
          accountId,
          depotId,
          paymentId,
          amount,
          date,
        ),
      );
    },

    toggleMatchedPaymentSendingFlag: (type, id) => {
      dispatch(accountingActions.toggle_matched_payment_sending_flag(type, id));
    },

    registerMPLRepayment: (
      originatorCreditId,
      number,
      date,
      principal,
      interest,
      penalty,
      totalRemainingPrincipal,
      originatorId,
      creditEnded,
    ) => {
      date = moment(date).format("YYYY-MM-DD");

      dispatch(
        accountingActions.register_mpl_payment(
          originatorCreditId,
          number,
          date,
          principal,
          interest,
          penalty,
          totalRemainingPrincipal,
          originatorId,
          creditEnded,
        ),
      );
    },

    getOriginators: () => {
      dispatch(originatorActions.get_originators());
    },

    confirmMatchedInvestorDeposit: (investorDepositId, depotId) => {
      dispatch(
        accountingActions.confirm_matched_investor_deposit(
          investorDepositId,
          depotId,
        ),
      );
    },

    investorDepositDepotIdOverride: (investorDepositId, depotId) => {
      dispatch(
        accountingActions.investordeposit_depotid_override(
          investorDepositId,
          depotId,
        ),
      );
    },

    getCreditByGuid: (guid) => {
      dispatch(accountingActions.get_credit_by_guid(guid));
    },

    changeSolvenPaidParts: (principal, interest, fees) => {
      dispatch(
        accountingActions.change_solven_paid_parts(principal, interest, fees),
      );
    },
  };
}

export const accountingConnector = connect(mapStateToProps, mapDispatchToProps);
